import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeparatorComponent } from '@pc/separator';
import {
  BrokerFeeText,
  DestinationsToggleOptions,
  EmailQuoteText,
  QuoteCoversData,
  QuoteTripDetailsData,
  TravelersAmountText,
  TripDetailsIcons
} from '@pc/common';
import { QuoteOverviewTripDetailsComponent } from './quote-overview-trip-details/quote-overview-trip-details.component';
import { QuoteOverviewCoverSectionComponent } from './quote-overview-cover-section/quote-overview-cover-section.component';
import { QuoteOverviewEmailComponent } from './quote-overview-email/quote-overview-email.component';
import { QuoteOverviewBrokerSectionComponent } from './quote-overview-broker-section/quote-overview-broker-section.component';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'pc-quote-overview-content',
  standalone: true,
  imports: [
    CommonModule,
    SeparatorComponent,
    QuoteOverviewTripDetailsComponent,
    QuoteOverviewCoverSectionComponent,
    QuoteOverviewBrokerSectionComponent,
    QuoteOverviewEmailComponent
  ],
  templateUrl: './quote-overview-content.component.html',
  styleUrl: './quote-overview-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteOverviewContentComponent {
  public gstRate = input<number>();
  public quoteTripDetailsData = input.required<QuoteTripDetailsData>();
  public quoteCoversData = input.required<QuoteCoversData[]>();
  public travelersAmountText = input.required<TravelersAmountText>();
  public selectedDestinationAlt = input.required<string>();
  public tripDetailsIcons = input.required<TripDetailsIcons>();
  public destinationsToggleOptions = input.required<DestinationsToggleOptions>();
  public brokerFeeTexts = input<BrokerFeeText>();
  public emailQuoteTexts = input.required<EmailQuoteText>();
  public privacyPolicyLink = input.required<SafeHtml>();
  public showEmailSection = input<boolean>(true);
  public showSeparator = input<boolean>(false);
  public brokerFee = model<number>(0.0);
  public showBrokerFeeSection = input<boolean>(false);
}
